import React, { useEffect, useState } from 'react'
import PaymentBtn from '../../components/FormTools/PaymentBtn'
import { usePayOtherApps } from '../../services/hooks'
import { Button, Toast } from 'antd-mobile-v5'
import { WhiteSpace, WingBlank } from 'antd-mobile'
import { Redirect, useHistory, useLocation } from 'react-router-dom'
import { FormattedMessage } from 'react-intl'
import { getOtherAppsPaymentStatus } from '../../services/api'
import styles from '../DiveMasterForm/DiveMasterForm.module.css'

const PocketsApplicationResult = () => {
  const { state } = useLocation()
  // detail 只能经 history.state 传入（无详情接口）；直接访问 URL 时 state 缺失，兜底回列表页防白屏
  const initialDetail = state && state.detail
  const isAutoRenewJump = state && state.isAutoRenewJump
  const [detail, setDetail] = useState(initialDetail)
  const { replace, push } = useHistory()
  const { runAsync: toPay, loading } = usePayOtherApps()

  // 支付成功后整页 reload，history.state 仍是旧快照（paid 未更新），支付按钮会残留。
  // 进入页面时按 code 调 paymentStatus 自愈拉最新支付状态（与 FuiouQrPopup 判定同源端点），
  // 已支付则刷新 paid 隐藏支付按钮。仅 mount 时执行一次
  useEffect(() => {
    if (!initialDetail || !initialDetail.code || initialDetail.paid) return
    let cancelled = false
    getOtherAppsPaymentStatus(initialDetail.code).then(({ data, error }) => {
      if (cancelled || error || !data) return
      setDetail((prev) => ({
        ...prev,
        paid: data.paid === true,
        paymentMethod: data.paymentMethod || prev.paymentMethod,
      }))
    })
    return () => {
      cancelled = true
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  // 依赖 code 值而非 detail 对象：自愈 setDetail 更新 detail 后不重跑，避免重复弹跳 auto_renew
  const detailCode = detail && detail.code
  useEffect(() => {
    if (isAutoRenewJump && detailCode) {
      const params = { code: detailCode, applicationType: 'MEMBER_APPLICATION_OTHER' }
      Toast.show({
        content: '即将跳转到自动更新签署流程...',
        afterClose: () => push('/auto_renew', params),
      })
    }
  }, [isAutoRenewJump, detailCode, push])

  // state 缺失（直接访问 URL/外部跳转）无上下文：回列表页
  if (!state) return <Redirect to="/pockets_apps_list" />

  return detail && Object.keys(detail).length > 0 ? (
    <>
      <div className={styles.applicationNo}>
        <div className={styles.applicationTitle}>
          <FormattedMessage id="dm-form-applicationNo" />
        </div>
        <div className={styles.number}>{detail.code}</div>
      </div>
      {!detail.paid && (
        <WingBlank>
          <PaymentBtn code={detail.code} paymentFn={toPay} payApplicationType={'MEMBER_APPLICATION_OTHER'} />
        </WingBlank>
      )}
      <WhiteSpace />
      <WingBlank>
        <Button color="primary" fill="outline" block disabled={loading} onClick={() => replace('/pockets_apps_list')}>
          <FormattedMessage id="common-back" />
        </Button>
      </WingBlank>
    </>
  ) : null
}

export default PocketsApplicationResult
